// extracted by mini-css-extract-plugin
module.exports = {"catalogContainer":"catalogContainer_catalogContainer__1hy0x","catalogSearchBar":"catalogContainer_catalogSearchBar__2aPqC"};